import script from "./updateOrganization.vue?vue&type=script&setup=true&lang=ts"
export * from "./updateOrganization.vue?vue&type=script&setup=true&lang=ts"

import "./updateOrganization.vue?vue&type=style&index=0&id=7cf6e123&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cf6e123"]])

export default __exports__